/**
 * Created by jerome on 14/10/2018.
 */
import Animation from '../../core/Animation'
import NSSSVGAnimator from '../../core/NSSSVGAnimator'
import { Matrix } from 'transformation-matrix-js'
const easeOutElastic = function (t, b, c, d) {
  let s = 1.70158
  let p = 0
  let a = c
  if (t == 0) return b
  if ((t /= d) == 1) return b + c
  if (!p) p = d * .3
  if (a < Math.abs(c)) {
    a = c
    s = p / 4
  }
  else s = p / (2 * Math.PI) * Math.asin(c / a)
  return a * Math.pow(2, -10 * t) * Math.sin((t * d - s) * (2 * Math.PI) / p) + c + b
}
export default class InGlitchyDeform extends Animation {
  constructor (svgDatas, options, onUpdate, onComplete) {
    super(onUpdate, onComplete)
    this.noise = NSSSVGAnimator.getNoise()
    this._svgDatas = svgDatas

    this._scaleNoise = options.scaleNoise | 2
    this._force = options.force | 60
    this._wave = options.wave | 300
    this._duration = options.duration | 60

    this._scale = 0
    this._anchor = {
      x: this._svgDatas.bounds[0] + this._svgDatas.bounds[2] / 2,
      y: this._svgDatas.bounds[1] + this._svgDatas.bounds[3] / 2
    }

    this._forceHalf = this._force / 2
  }

  update () {
    this.updateIn()
    var scaleNoise = 1

    let vx, vy
    this._scale = easeOutElastic(this._time, 0, this._duration, this._duration) / this._duration
    //this._scale = this._time/this._duration
    this._matrix = new Matrix()
    this._matrix.translate(this._anchor.x, this._anchor.y).scaleU(this._scale).translate(-this._anchor.x, -this._anchor.y)

    let p, pMain, rx, ry, inv = 1 - this._scale
    this._svgDatas.shapes.forEach(shape => {
      shape.points.forEach(p => {
        pMain = p.main;
        [p.main, p.left, p.right].forEach(pt => {
          if (!pt) return

          //vx = (this.noise.noise2D((pt.sx/this._svgDatas.bounds[2]*scaleNoise), (pt.sy/this._svgDatas.bounds[3]*scaleNoise))  * 0.5 )*wave;
          vy = (this.noise.noise2D((pt.sx / this._svgDatas.bounds[2] * this._scaleNoise + this._time), (pt.sy / this._svgDatas.bounds[3] * this._scaleNoise)) * 0.5 ) * this._wave
          pt.x = pt.sx + vy * inv
          pt.y = pt.sy + vy * inv
          rx = (Math.random() * this._force - this._forceHalf) * this._scale * inv
          //ry = (Math.random()*this._force-this._forceHalf)*this._scale*inv
          p = this._matrix.applyToPoint(pt.x, pt.y)
          this._svgDatas.updatePoint(pt, p.x + rx, p.y)
        })
      })
    })
    this.updateOut()
  }

  dispose () {
    super.dispose()
  }
}